import * as types from '../../../lib/actionTypes.es6';

export var loadOrgConfigRequest = function(organizationGuid) {
  return { type: types.LOAD_ORG_CONFIG_REQUEST, payload: organizationGuid };
};
export var loadOrgConfigSuccess = function(payload) {
  return { type: types.LOAD_ORG_CONFIG_SUCCESS, payload: payload };
};
export var loadOrgConfigFailure = function(error) {
  return { type: types.LOAD_ORG_CONFIG_FAILURE, payload: error };
};
export var clearOrgConfig = function() {
  return { type: types.CLEAR_ORG_CONFIG };
};
